/* DinoStudio — full-screen "power-up" page-transition loader.
   Covers full-page navigations (product / collection / cart / pages / search) with a
   branded "POWERING UP…" label + running bar. Does NOT touch add-to-cart (AJAX) — that keeps the ki-charge button effect.
   Config: window.OVERNINE.loader = { enabled, label, minShow, safety }. */
(function () {
  'use strict';
  var CFG = (window.OVERNINE && window.OVERNINE.loader) || {};
  if (CFG.enabled === false) return;
  var el = document.getElementById('on9-loader');
  if (!el) return;
  var MIN_SHOW = CFG.minShow || 450;   // ms overlay stays up once shown (anti-flicker)
  var SAFETY   = CFG.safety   || 8000; // ms hard cap so a stalled load can't trap the user
  var KEY = 'on9-nav';
  var shownAt = 0, hideTimer = null, safetyTimer = null;

  function show() {
    if (el.classList.contains('show')) return;
    el.classList.remove('out');
    el.classList.add('show');
    document.documentElement.classList.add('on9-loading');
    el.setAttribute('aria-hidden', 'false');
    shownAt = Date.now();
    clearTimeout(safetyTimer); safetyTimer = setTimeout(hide, SAFETY);
  }
  function hide() {
    clearTimeout(safetyTimer);
    var wait = Math.max(0, MIN_SHOW - (Date.now() - shownAt));
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      el.classList.add('out');
      document.documentElement.classList.remove('on9-loading');
      setTimeout(function () {
        el.classList.remove('show', 'out');
        el.setAttribute('aria-hidden', 'true');
      }, 340);
    }, wait);
  }

  function eligible(a, e) {
    if (!a || e.defaultPrevented) return false;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    var target = a.getAttribute('target');
    if (target && target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (a.hasAttribute('data-no-loader') || (a.closest && a.closest('[data-no-loader]'))) return false;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return false;
    var url; try { url = new URL(a.href, location.href); } catch (_) { return false; }
    if (url.origin !== location.origin) return false;
    // same page + only hash differs -> not a navigation
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return false;
    return true;
  }

  function markNav() { try { sessionStorage.setItem(KEY, String(Date.now())); } catch (_) {} }

  // Outgoing: intercept eligible link clicks (bubble phase; respect prior preventDefault)
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!eligible(a, e)) return;
    markNav(); show();
  });

  // Outgoing: GET form submits that navigate (e.g. search)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || e.defaultPrevented) return;
    if (f.hasAttribute('data-no-loader')) return;
    if ((f.getAttribute('method') || 'get').toLowerCase() === 'post') return;
    var url; try { url = new URL(f.getAttribute('action') || location.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    markNav(); show();
  });

  // Incoming: if we arrived via an intercepted nav, keep the loader up until load, then fade.
  function onReady() {
    var t = null; try { t = sessionStorage.getItem(KEY); } catch (_) {}
    if (!t) return;
    try { sessionStorage.removeItem(KEY); } catch (_) {}
    shownAt = parseInt(t, 10) || Date.now();  // min-show measured from the original click
    hide();
  }
  if (document.readyState === 'complete') onReady();
  else window.addEventListener('load', onReady);

  // Back/forward restore from bfcache: hide instantly, don't leave a stale overlay.
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    try { sessionStorage.removeItem(KEY); } catch (_) {}
    clearTimeout(hideTimer); clearTimeout(safetyTimer);
    el.classList.remove('show', 'out');
    document.documentElement.classList.remove('on9-loading');
    el.setAttribute('aria-hidden', 'true');
  });

  window.ON9_LOADER = { show: show, hide: hide };
})();
